export default __webpack_public_path__ + "static/cardsSectionBg-89b9e3eb4a1029d510b0e6693891ab88.png";